const mobileRouteNames = {
  AddColleague: "add-colleague",
  AddProfilePhoto: "add-profile-photo",
  AddIntroVideo: "add-intro-video",
  Audio: "audio",
  CheckEmail: "checkEmail",
  City: "city",
  CreateMessage: "create-message",
  Disclosures: "disclosures",
  DisclosuresNo: "disclosuresNo",
  DisclosuresYes: "disclosuresYes",
  Email: "email",
  EditAboutMe: "edit-aboutme",
  EditProfile: "edit-profile",
  ForgotPassword: "forgotPassword",
  Profile: "profile-navigator",
  ProfileInfo: "profile-info",
  Settings: "settings",
  HelpMe: "help-me",
  HelpThem: "help-them",
  Discover: "discover",
  HomeTabNavigator: "home",
  InboxNotifications: "inbox-notifications",
  IntroVideo: "intro-video",
  Listen: "listen",
  Login: "login",
  LoginNavigator: "login-navigator",
  MainNavigator: "main-navigator",
  MentorshipRequests: "mentorship-requests",
  CreateMessageNavigator: "create-message-navigator",
  Name: "name",
  NoInternet: "no-internet",
  Password: "password",
  ProfilePhoto: "profile-photo",
  Read: "read",
  RecordVideoNewMessage: "record-video-new-message",
  RecordAudioNewMessage: "record-audio-new-message",
  Role: "role",
  SearchMessage: "search-message",
  SelectColleague: "select-colleague",
  SelectProfilePhoto: "select-profile-photo",
  SelectRole: "select-role",
  SelectUsersNavigator: "select-users",
  SignUp: "signup",
  Speciality: "specialty",
  State: "state",
  TakePhotoNewMessage: "take-photo-new-message",
  Text: "text",
  Video: "video",
  ViewMessageScreen: "view-message-screen",
  ViewMentorshipMessageScreen: "view-mentorship-message-screen",
  ViewMentorshipProgramModule: "view-mentorship-program-module",
  ViewVideoMessage: "view-video-message",
  ViewIntroVideo: "view-intro-video",
  Watch: "watch",
  Workspace: "workspace",
  GetListedAppScreen: "get-listed-app",
  HiGnomeChat: "hignome-chat",
  Grit: "grit",
  MentorshipDashboard: "mentorship-dashboard",
  EnterPhone: "enter-phone",
  EditMessageScreen: "edit-message-screen"
};

export default mobileRouteNames;
